import { FaultCodes } from '@feedflo/fault-codes';

export const addComma = (num) => {
  if (num === undefined) return '';
  return num.toLocaleString();
};

export const ALERTABLE_FAULT_CODES = [
  FaultCodes.EMPTY_PIPE,
  FaultCodes.AUGER_RUNNING,
  FaultCodes.INACTIVE_AUGER,
  FaultCodes.BIN_CONTROLLER_SLIDE_OPEN,
  FaultCodes.BIN_CONTROLLER_HARD_LOCK_DOWN,
  FaultCodes.DEVICE_UNREACHABLE,
];

export default [addComma, ALERTABLE_FAULT_CODES];
